import { CustomYup } from 'validations/CustomYup'
import { emailFieldSchema, passwordFieldSchema } from '../helpers'

const loginSchema = CustomYup.object().shape({
  email: emailFieldSchema.required(),
  password: passwordFieldSchema.required(),
})

export default loginSchema
